import { useEffect } from 'react';
import { useAngularContext } from 'AngularContext';
import { type CohortSectionOffer } from 'CohortSectionOffer';
import { useErrorLogService } from 'ErrorLogging';
import { type CurrentUser } from 'Users';

/*
    A registration screen cannot render without a CohortSectionOffer. If one is missing the UI is
    broken for that learner, so log it and send them home.
*/
export function useRedirectHomeWithoutCohortSectionOffer({
    cohortSectionOffer,
    currentUser,
    // The retired directive's name, which the log message and the goHome label both read.
    screenName,
}: {
    cohortSectionOffer: CohortSectionOffer | undefined;
    currentUser: CurrentUser;
    screenName: string;
}): void {
    const ErrorLogService = useErrorLogService();
    const injector = useAngularContext();

    useEffect(() => {
        if (cohortSectionOffer) return;

        ErrorLogService.notifyInProd('Trying to render a registration UI without a CohortSectionOffer', undefined, {
            userId: currentUser.id,
            screenName,
        });
        injector
            ?.get<{ goHome: (label: string) => void }>('$rootScope')
            ?.goHome(`${screenName}_dir::no_cohort_section_offer`);
    }, [cohortSectionOffer, ErrorLogService, injector, currentUser.id, screenName]);
}
